/** Deterministic RNG for client-side NPC patrol (multiplayer position sync). */

export function hashString(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function mulberry32(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function npcPatrolRng(
  layerSeedId: string,
  instanceId: string,
  step: number
): () => number {
  return mulberry32(hashString(`${layerSeedId}:${instanceId}:${step}`));
}

export function randBetween(rng: () => number, min: number, max: number): number {
  return min + rng() * (max - min);
}

export function randIntBetween(rng: () => number, min: number, max: number): number {
  return Math.floor(randBetween(rng, min, max + 1));
}
